import Collection from '../../utils/Collection';

import {
  FETCH_LESSON_REVIEWS_BY_TUTOR_SENT,
  FETCH_LESSON_REVIEWS_BY_TUTOR_SUCCEEDED,
  FETCH_LESSON_REVIEWS_BY_TUTOR_FAILED,
} from '../../actions/lessonReview';

import { CLEAR_TUTOR_DATA } from '../../actions/tutor';

const initialState = {
  loading: false,
  reviews: [],
  numOfReviews: 0,
};

export default function tutorLessonReviewReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case CLEAR_TUTOR_DATA:
      return initialState;
    case FETCH_LESSON_REVIEWS_BY_TUTOR_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_LESSON_REVIEWS_BY_TUTOR_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_LESSON_REVIEWS_BY_TUTOR_SUCCEEDED:
      return {
        ...state,
        loading: false,
        reviews: Collection.reset(state.lessonReviews, payload.lesson_reviews),
        numOfReviews: payload.num_of_reviews,
      };
    default:
      return state;
  }
}
